import { ReactLinkProps } from './types'
import './ReactLink.scss'

const ReactLink = (props: ReactLinkProps) => {
  const {
    linkTextValue,
    linkUrlValue,
    linkTextIconValue,
    linkIconAltTextValue,
    haslinkTextIcon = true,
    iconClickable = false
  } = props
  const linkURL = linkUrlValue ? linkUrlValue : linkUrlValue

  const getIcon = (haslinkTextIcon: string | boolean) => {
    return haslinkTextIcon && <img src={linkTextIconValue} alt={linkIconAltTextValue} className='link-icon' />
  }
  return (
    <>
      {linkTextValue && (
        <div key='linkContainer' className='linkContainer' data-testid='link-container'>
          <a href={linkURL} target='_self' title={linkTextValue}>
            {linkTextValue}
          </a>
          {!iconClickable && getIcon(haslinkTextIcon)}
          {iconClickable && (
            <a href={linkURL} target='_self' title={linkTextValue}>
              {getIcon(haslinkTextIcon)}
            </a>
          )}
        </div>
      )}
    </>
  )
}

export default ReactLink
